module.exports = __webpack_public_path__ + "fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 1146
// module chunks = 14